type TBuildSettlementOptions = {
  settlementOptions: {
    label: string;
    value: string;
  }[];
  label: string;
  value: string;
};

export const buildSettlementOptions = ({ settlementOptions, label, value }: TBuildSettlementOptions) => {
  const isSettlementExists = settlementOptions.some((option) => option.value === value);

  return isSettlementExists ? settlementOptions : [{ label, value }, ...settlementOptions];
};
